<template lang="pug">
  .perfis.columns(v-if='items.length')
    .column.col-4.col-xs-12.col-sm-6(v-for='p in items')
      label.form-switch(:class="{'inativo': p.inativo}")
        input(type='checkbox' v-model='p.selected', :disabled='disabled' @change="onChange(p)")
        i.form-icon
        |  {{ p.descricao }}
</template>

<script>
import Perfil from '@/models/Perfil'
import transliterate from '@/lib/transliterate'

export default {
  vuex: {
    'sistema/perfis': {
      state: ['list'],
      actions: ['fetchList'],
    },
  },
  props: {
    value: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      initialIds: [],
    }
  },
  computed: {
    selecteds() {
      return this.items
        .filter(p => p._changed)
        .map(p => {
          let item = { id: p.id }
          if (p._destroy) {
            item._destroy = true
          }

          return item
        })
    },
  },
  methods: {
    isSelected(item) {
      for (let i in this.value) {
        if (this.value[i].id === item.id) {
          return true
        }
      }

      return false
    },

    onChange(item) {
      item._destroy = !item.selected && this.initialIds.indexOf(item.id) > -1
      item._changed =
        (item.selected && this.initialIds.indexOf(item.id)) === -1 ||
        item._destroy
      this.$emit('input', this.selecteds)
    },
  },

  created() {
    this.fetchList().then(response => {
      for (const p of response || []) {
        const item = { ...p, selected: this.isSelected(p), _changed: false }
        if (item.selected) {
          this.initialIds.push(item.id)
        }
        this.items.push(item)
      }
      this.$emit('input', this.selecteds)
    })
  },
}
</script>

<style lang="stylus">
.perfis
  .inativo
    text-decoration line-through
    opacity .8
</style>
